import React from 'react';
import './index.css'

const Footer = ({ translate } : { translate: Function }) => (
  <footer className="footer-generic js-footer">
    <p className="footer-generic--first-p">{translate(`common.footer.first`)}</p>
    <p>{translate(`common.footer.second`)}</p>
    <p>{translate(`common.footer.third`)}</p>
  </footer>
)

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/footer/index.js